import assert from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditSavedMetadataManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';
import type {ManifestationV4} from '../types';

export const useAssertSavedManifestation = (
  manifestationId: string,
): ManifestationV4 => {
  const selector = useCreateSelectorById(
    manifestationId,
    selectMetadataEditSavedMetadataManifestationById,
  );
  const manifestation = useAppSelector(selector);
  return assert(manifestation, 'useAssertSavedManifestation: not loaded');
};
